import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { Button, CircularProgress } from "@nextui-org/react";
import { useGlobalData } from "@/contexts/GlobalData";
import LottieAnimation from "../LottieAnimation";
import getAnimation from "@/common/function/getAnimation";
import { forwardRef, useEffect, useRef } from "react";
export type ButtonStatus = "normal" | "disabled" | "loading" | "processing" | "error" | "success";
interface PrimaryButtonPropsType extends GeneralPropsType {
  status: ButtonStatus;
  statusKey: string;
  clickDelay?: number;
}
function PrimaryButton({
  children,
  className,
  status = "normal",
  statusKey,
  clickDelay = 500,
  ...restProps
}: PrimaryButtonPropsType | any, ref: any) {
  const timeOut = useRef<NodeJS.Timeout | null>(null);
  const isProcessing = useRef<boolean>(false);
  const {
    translate
  } = useGlobalData();
  const {
    onClick,
    ...rest
  } = restProps;
  const handleClick = (e: Event) => {
    if (isProcessing.current) return;
    isProcessing.current = true;
    onClick?.(e);
    timeOut.current = setTimeout(() => {
      isProcessing.current = false;
    }, clickDelay);
  };
  useEffect(() => {
    return () => {
      if (timeOut.current) {
        clearTimeout(timeOut.current);
      }
    };
  }, []);
  return <button onClick={handleClick} className={clsx("not_apply_adjust_color_tbk active:brightness-50 duration-200 select-none", styles.button, styles[status], styles.button_text, className)} disabled={status != "normal"} {...rest} data-sentry-component="PrimaryButton" data-sentry-source-file="index.tsx">
            {status === "normal" && (children ?? translate(`${statusKey}_normal`))}
            {status != "normal" && <div className="flex items-center gap-2 justify-center">
                    {status == "loading" && <CircularProgress aria-label="Loading..." color="secondary" classNames={{
        svg: "w-6 h-6"
      }} />}
                    {status == "success" && <LottieAnimation src={getAnimation("success_button")} loop={false} autoplay={true} className="w-6 h-6" />}
                    {status == "error" && <LottieAnimation src={getAnimation("error_button")} loop={false} autoplay={true} className="w-6 h-6" />}

                    <span className="not_apply_adjust_color_tbk">
                        {statusKey ? translate(`${statusKey}_${status}`) : rest[`${status}-message`] ?? translate(`button_${status}_message`)}
                    </span>
                </div>}
        </button>;
}
export default PrimaryButton;